import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

/**
 * Guard that redirects from /calls to /conversations while preserving
 * matrix params (;id=...) and query params (?bid=...).
 *
 * This is needed because Angular's simple redirectTo doesn't preserve params.
 */
@Injectable({
  providedIn: 'root'
})
export class CallsRedirectGuard {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): UrlTree {
    // Get matrix params (e.g., ;id=abc)
    const matrixParams = route.params;

    // Get query params (e.g., ?bid=xyz)
    const queryParams = route.queryParams;

    // Build the new URL with /conversations
    const urlTree = this.router.createUrlTree(
      ['/conversations', matrixParams],
      { queryParams }
    );

    return urlTree;
  }
}
